import React from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import './HomePage.css';

const HomePage = () => {
  const { t } = useTranslation();

  return (
    <div className="home-page">
      {/* 메타 정보 설정 */}
      <Helmet>
        <title>{t('meta.home.title')}</title>
        <meta name="description" content={t('meta.home.description')} />
        <meta property="og:title" content={t('meta.home.title')} />
        <meta property="og:description" content={t('meta.home.description')} />
      </Helmet>

      {/* 페이지 내용 */}
      <h1>{t('message.home.title')}</h1>
      <p>{t('message.home.description2')}</p>
      <p>{t('message.home.description3')}</p>
    </div>
  );
};

export default HomePage;
